
const baseSuccessCallback = (event) => {
  event.preventDefault();
  event.target.dispatchEvent(new CustomEvent("sanrix.form.valid"));
};

const baseErrorCallback = (event) => {
  event.preventDefault();
  event.target.dispatchEvent(new CustomEvent("sanrix.form.not-valid"));
};

export const callbacks = {
  base: {
    resetTimeout: 500,
    successCallback: baseSuccessCallback,
    errorCallback: baseErrorCallback,
  },
};
